import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

type CheckSubscriptionResponse = {
  is_account_user: boolean;
  is_subscription_user: boolean;
  is_visible_to_current_user: boolean;
  user_name: string;
  subscription_role: string;
  subscription_status: 'invited' | 'accepted' | 'uploaded';
};

export function getSubscriptionStatus(params: {
  email: string;
  subscription_id: number;
}) {
  return axios.post<CheckSubscriptionResponse>(
    `/api/v2/memberships/check_subscription`,
    {
      email: params.email,
      subscription_id: params.subscription_id
    }
  );
}

type UnsubscribedMembership = {
  id: number;
  user_id: number;
  role: string;
  email: string;
  full_name: string;
  invited_at: string;
  unsubscribed_at: string;
};

type GetUnsubscribedUsersResponse = {
  unsubscribed: UnsubscribedMembership[];
  pagination: {
    total_count: number;
    total_pages: number;
    current_page: number;
  };
};

export function getUnsubscribedUsers(subscriptionId: number, params: any = {}) {
  return axios.get<GetUnsubscribedUsersResponse>(
    `/api/v2/memberships/unsubscribed?subscription_id=${subscriptionId}`,
    {
      params
    }
  );
}

export function useGetUnsubscribedUsers(
  subscriptionId: number,
  params: any = {}
) {
  return useQuery({
    queryKey: ['subscriptions', subscriptionId, 'unsubscribed', params],
    queryFn: () =>
      getUnsubscribedUsers(subscriptionId, params).then(
        response => response.data
      )
  });
}
